<template>
  <div class="etms-router-body">
    <el-tabs v-model="activepane" @tag-click="handlePaneClick">
      <el-tab-pane label="收货人管理" name="receipt">
        <div class="etms-router-search">
          <span class="etms-router-search-label fl">查询关键字</span>
          <el-input size="mini" placeholder="收货人/公司/电话" class="el-width-200 etms-router-search-element fl"></el-input>
          <el-tooltip class="item" effect="dark" content="添加收货人信息" placement="top">
            <el-button size="mini" @click="insetrContact" class="etms-router-search-button fr" type="primary" icon="el-icon-plus"></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="搜索" placement="top">
            <el-button size="mini" @click="search" class="etms-router-search-button fr" type="primary" icon="el-icon-search"></el-button>
          </el-tooltip>
          <div class="clear"></div>
        </div>
        <el-table :border="true" :data="contacts" class="etms-router-list">
          <el-table-column type="index" label="序号" align="center"></el-table-column>
          <el-table-column label="联系人" prop="ContactName" width="180px"></el-table-column>
          <el-table-column label="公司" prop="CompanyName"></el-table-column>
          <el-table-column label="地址" prop="Address" :formatter="formatterRegion">
          </el-table-column>
          <el-table-column label="手机号码" prop="MobilePhone" width="180px"></el-table-column>
          <el-table-column label="电话号码" prop="Phone" width="180px"></el-table-column>
          <el-table-column label="邮编" prop="Zipcode" width="120px"></el-table-column>
          <el-table-column label="操作" align="center" width="100px">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="修改收货人信息" placement="top">
                <el-button size="mini" type="primary" @click="handleContactEdit(scope.$index,scope.row)" icon="el-icon-edit-outline" circle></el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="删除收货人信息" placement="top">
                <el-button size="mini" type="danger" @click="handleContactDelete(scope.$index, scope.row)" icon="el-icon-delete" circle></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="发货人管理" name="sender">
        <div class="etms-router-search">
          <span class="etms-router-search-label fl">查询关键字</span>
          <el-input size="mini" placeholder="发货人/公司/电话" class="el-width-200 etms-router-search-element fl"></el-input>
          <el-tooltip class="item" effect="dark" content="添加发货人信息" placement="top">
            <el-button size="mini" @click="insetrContact" class="etms-router-search-button fr" type="primary" icon="el-icon-plus"></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="搜索" placement="top">
            <el-button size="mini" @click="search" class="etms-router-search-button fr" type="primary" icon="el-icon-search"></el-button>
          </el-tooltip>
          <div class="clear"></div>
        </div>
        <el-table :border="true" :data="contacts" class="etms-router-list">
          <el-table-column type="index" label="序号" align="center"></el-table-column>
          <el-table-column label="联系人" prop="ContactName" width="180px"></el-table-column>
          <el-table-column label="公司" prop="CompanyName"></el-table-column>
          <el-table-column label="地址" prop="Address" :formatter="formatterRegion">
          </el-table-column>
          <el-table-column label="手机号码" prop="MobilePhone" width="180px"></el-table-column>
          <el-table-column label="电话号码" prop="Phone" width="180px"></el-table-column>
          <el-table-column label="邮编" prop="Zipcode" width="120px"></el-table-column>
          <el-table-column label="操作" align="center" width="100px">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="修改发货人信息" placement="top">
                <el-button size="mini" type="primary" @click="handleContactEdit(scope.$index,scope.row)" icon="el-icon-edit-outline" circle></el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="删除发货人信息" placement="top">
                <el-button size="mini" type="danger" @click="handleContactDelete(scope.$index, scope.row)" icon="el-icon-delete" circle></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :title="dialogtitle" :visible.sync="dialogvisible" :modal-append-to-body="false" width="780px" center>
      <el-form ref='form' v-model="form" label-width="120px" class="el-form-half etms-dialog-form">
        <el-form-item label="联系人：">
          <el-input size="mini" placeholder="请填写联系人信息" class="el-width-200" v-model="form.ContactName"></el-input>
        </el-form-item>
        <el-form-item label="公司：">
          <el-input size="mini" placeholder="请填写联系公司" class="el-width-200" v-model="form.CompanyName"></el-input>
        </el-form-item>
        <el-form-item label="国家：" v-show="receiptstate">
          <el-select size="mini" placeholder="请选择国家" class="el-width-200" filterable></el-select>
        </el-form-item>
        <el-form-item label="地区：" v-show="receiptstate">
          <el-select size="mini" placeholder="州省" class="el-width-70" v-model="form.Province" filterable allow-create default-first-option></el-select>
          <el-select size="mini" placeholder="城市" class="el-width-70" v-model="form.City" filterable allow-create default-first-option></el-select>
          <el-select size="mini" placeholder="区县" class="el-width-70" v-model="form.County" filterable allow-create default-first-option></el-select>
        </el-form-item>
        <el-form-item label="地区：" v-show="!receiptstate">
          <el-cascader size="mini" placeholder="请选择发货方所在地区" :options="regions" v-model="form.Region" filterable class="el-width-200"></el-cascader>
        </el-form-item>
        <el-form-item label="街道：">
          <el-input size="mini" placeholder="请填写联系人所在街道" class="el-width-200" v-model="form.Street"></el-input>
        </el-form-item>
        <el-form-item label="详细地址：">
          <el-input size="mini" placeholder="请填写联系人详细地址(请具体到门牌)" class="el-width-200" v-model="form.Address"></el-input>
        </el-form-item>
        <el-form-item label="备用地址：">
          <el-input size="mini" placeholder="请填写联系人备用地址(请具体到门牌)" class="el-width-200" v-model="form.StandbyAddress"></el-input>
        </el-form-item>
        <el-form-item label="手机号码：">
          <el-input size="mini" placeholder="请填写联系人手机号码" class="el-width-200" v-model="form.MobilePhone"></el-input>
        </el-form-item>
        <el-form-item label="电话号码：">
          <el-input size="mini" placeholder="请填写联系人电话号码" class="el-width-200" v-model="form.Phone"></el-input>
        </el-form-item>
        <el-form-item label="传真：">
          <el-input size="mini" placeholder="请填写联系人传真号码" class="el-width-200" v-model="form.Fax"></el-input>
        </el-form-item>
        <el-form-item label="邮编：">
          <el-input size="mini" placeholder="请填写联系人所在地邮编" class="el-width-200" v-model="form.Zipcode"></el-input>
        </el-form-item>
        <el-form-item label="邮箱：">
          <el-input size="mini" placeholder="请填写联系人电子邮箱" class="el-width-200" v-model="form.Email"></el-input>
        </el-form-item>
        <el-form-item label="平台账号ID：">
          <el-input size="mini" placeholder="请填写联系人平台账号ID" class="el-width-200" v-model="form.PlatformAccountId"></el-input>
        </el-form-item>
        <div class="clear"></div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogvisible=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="dialogSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  data () {
    return {
      regions: this.regionmodule.regions,
      activepane: 'receipt',
      dialogvisible: false,
      receiptstate: true,
      dialogtitle: '收货人',
      contacts: [
        {
          OptimisticLock: '',
          OldOptimisticLock: '',
          ContactId: '',
          ContactName: '张三',
          CompanyName: '广州凯捷物流供应链有限公司',
          RegionId: '',
          RegionName: '美国',
          Region: [],
          Province: '佛罗里',
          City: '旧金山',
          County: '山河',
          Street: '唐人',
          Address: '第三方叼翻天惹她色弱4号',
          StandbyAddress: '',
          MobilePhone: '13800138000',
          Phone: '020-28101281',
          Fax: '',
          Zipcode: '12345',
          Email: 'xiaoxiangnan@gmail.com',
          PlatformAccountId: ''
        }
      ],
      form: {
        OptimisticLock: '',
        OldOptimisticLock: '',
        ContactId: '',
        ContactName: '张三',
        CompanyName: '广州凯捷物流供应链有限公司',
        RegionId: '',
        RegionName: '美国',
        Region: [],
        Province: '佛罗里',
        City: '旧金山',
        County: '山河',
        Street: '唐人',
        Address: '第三方叼翻天惹她色弱4号',
        StandbyAddress: '',
        MobilePhone: '13800138000',
        Phone: '020-28101281',
        Fax: '',
        Zipcode: '12345',
        Email: 'xiaoxiangnan@gmail.com',
        PlatformAccountId: ''
      }
    }
  },
  methods: {
    handlePaneClick () {

    },
    search () {
      if (activepane === "receipt") {
        receiptstate = true
        this.dialogtitle = '收货人'
      }
      else {
        receiptstate = false
        this.dialogtitle = '发货人'

      }
    },
    insetrContact () {
      this.dialogvisible = true
    },
    formatterRegion (row, column, cellvalue) {
      return row.RegionName + ' ' + row.Province + ' ' + row.City + ' ' + row.County + ' ' + row.Street + ' ' + row.Address
    },
    handleContactEdit (index, row) {
      this.dialogvisible = true
    },
    handleContactDelete (index, row) {

    },
    dialogSave () { }
  }
}
</script>

<style scoped>
@import "../../../css/etms/home.css";
@import "../../../css/iconfont.css";
</style>



// WEBPACK FOOTER //
// src/components/etms/ctms/my_address.vue